import request from 'axios';
const BASE_URL = 'https://xsjinnang.ruizhiqi.com/jinnang/';
const Cost_Data_API = 'https://acgkb.ruizhiqi.com.cn/api/';
export const getProvInfo = params => { //获取省份信息
    return request({
        url: BASE_URL + "prov_info",
        // headers: {
        //     "Content-Type": "application/octet-stream",
        //     "Access-Control-Allow-Origin": "*",
        //     },
        methods: "get",
        params
    });
};
export const getTrade = params => { //获取行业
    return request({
        url: BASE_URL + "trade",
        methods: "get",
        params
    });
}

export const getQueryEffect = params => { //搜索推广主要信息查询
    return request({
        url: BASE_URL + "query_search_effect",
        methods: "get",
        params
    });
}

export const getSearchPeerInfo = params => { //同行案例查询
    return request({
        url: BASE_URL + "search_peer_info",
        methods: "get",
        params
    });
}

export const getHotKeyword = params => { //热门商业词推荐查询
    return request({
        url: BASE_URL + "get_hot_keyword",
        methods: "get",
        params
    });
}

export const getCsmTrend = params => { // 消费趋势 (24h)查询
    return request({
        url: BASE_URL + "new_csm_trend",
        methods: "get",
        params
    });
}

export const getPeerCompete = params => { // 投放地域
    return request({
        url: BASE_URL + "peer_compete",
        methods: "get",
        params
    });
}

export const getQueryFeed = params => { //信息流主要信息查询
    return request({
        url: BASE_URL + "query_feed_effect",
        methods: "get",
        params
    });
}

export const getFeedPeerInfo = params => { //信息流同行案例查询
    return request({
        url: BASE_URL + "feed_peer_info",
        methods: "get",
        params
    });
}

export const getFeedIdea = params => { //信息流同行优秀创意
    return request({
        url: BASE_URL + "feed_excellent_idea",
        methods: "get",
        params
    });
}
// 爱采购
export const getAcgCustData = params => { //爱采购客服及到期时间查询
    return request({
        url: BASE_URL + "acg/get_cust_data",
        methods: "get",
        params
    });
}

export const getAcgIndustry = params => { //爱采购行业查询
    return request({
        url: BASE_URL + "acg/get_acg_industry",
        methods: "get",
        params
    });
}

export const getAcgIndustryCase = params => { //爱采购行业案例查询
    return request({
        url: BASE_URL + "acg/get_industry_case",
        methods: "get",
        params
    });
}

export const getCustomer = params => { //推广客服查询
    return request({
        url: BASE_URL + "baidu/get_customer",
        methods: "get",
        params
    });
}
// 行业成本数据统计
export const GetDataFeiYiLiao = params => { //非医疗获取行业
    return request({
        url: Cost_Data_API + "Get_Data_FeiYiLiao",
        methods: "get",
        params
    });
}
export const GetDataYiLiao = params => { //医疗获取行业
    return request({
        url: Cost_Data_API + "Get_Data_YiLiao",
        methods: "get",
        params
    });
}
// 业务毛利查询
export const GetYeWuMaoLi = params => { 
    return request({
        url: Cost_Data_API + "Get_Data_YeWuMaoLi3",
        methods: "get",
        params
    });
}
export const GetYeWuMaoLi2 = params => { 
    return request({
        url: Cost_Data_API + "Get_Data_YeWuMaoLi4",
        methods: "get",
        params
    });
}
// 惠生活账户到期时间查询
export const getHshCustData = params => {
    return request({
        url: Cost_Data_API + "Data_Supports",
        mothods:"get",
        params
    })
}
export const getMTkebao = params => {
    return request({
        url: Cost_Data_API + "Get_Data_MT",
        mothods:"get",
        params
    })
}


export const getWhiteList = params => {
    return request({
        url: Cost_Data_API + "Get_Data_WhiteList",
        mothods:"get",
        params
    })
}

export const getWhiteTwoYearsCompany = params => {
    return request({
        url: Cost_Data_API + "Get_Data_TwoYearsCompany",
        mothods:"get",
        params
    })
}